export enum AllowedUrlParams {
  mortgageProduct = 'mortgageProduct',
  mortgageType = 'mortgageType',
  bankAccountDiscount = 'huisbankkorting',
  sustainabilityDiscount = 'duurzaamheidskorting',
  lang = 'lang'
}
